"use client";
import { usePublicT } from "../../public-locale";


import { useEffect, useRef } from "react";
import Header from "./Header";
import Footer from "./Footer";

interface PageShellProps { children: React.ReactNode; fullWidth?: boolean; }

export function useReveal() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const targets = el.querySelectorAll(".reveal");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reduceMotion || !("IntersectionObserver" in window)) {
      targets.forEach((target) => target.classList.add("visible"));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("visible");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });

    targets.forEach((target) => {
      target.classList.add("reveal-pending");
      observer.observe(target);
    });
    return () => observer.disconnect();
  }, []);
  return ref;
}

export default function PageShell({ children }: PageShellProps) {
  const t = usePublicT();
  const ref = useReveal();
  return (
    <div className="marketing-figma min-h-screen flex flex-col" style={{ background: "var(--background)" }} ref={ref}>
      <a className="skip-link" href="#main-content">{t("Skip to main content")}</a>
      <Header />
      <main id="main-content" className="flex-1" tabIndex={-1}>{t(children)}</main>
      <Footer />
    </div>
  );
}
